import { truncateAddress } from '@kwenta/sdk/utils'
import { useCallback } from 'react'

import { getBaseUrl } from 'containers/Connector/blockExplorer'
import {
	selectAbstractionDelegated,
	selectAccountContext,
	selectSessionActive,
	selectSessionInfo,
} from 'state/futures/selectors'
import { useAppSelector } from 'state/hooks'
import { selectOneClickTradingWalletAddress } from 'state/wallet/selectors'

export default function useAbstractionInfo() {
	const { network } = useAppSelector(selectAccountContext)

	const address = useAppSelector(selectOneClickTradingWalletAddress)
	const truncatedAddress = truncateAddress(address ?? '')
	const sessionInfo = useAppSelector(selectSessionInfo)
	const isDelegated = useAppSelector(selectAbstractionDelegated)

	const isSessionActive = useAppSelector(selectSessionActive)

	const openWallet = useCallback(() => {
		const url = getBaseUrl(network)
		window.open(`${url}/address/${address}`, '_blank')
	}, [address, network])

	return {
		address,
		truncatedAddress,
		openWallet,
		sessionInfo,
		isSessionActive,
		isDelegated,
	}
}
